import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 40,
		height: 40,
		rx: 20,
		fill: "#02A858"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.0664 21.2761L16.1704 26.3801L28.9304 13.6201",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCheckCircleFilled;
